import { useContext } from 'react';
import { useLocation, Navigate, createPath } from 'react-router-dom';
import AuthContext from './auth-context';

type RequireAuthProps = {
  children: JSX.Element;
};

export const useAuthContext = () => {
  return useContext(AuthContext);
};

export default function RequireAuth({ children }: RequireAuthProps) {
  const auth = useAuthContext();
  const location = useLocation();

  if (!auth.user) {
    return (
      <Navigate
        to={`/?to=${encodeURIComponent(createPath(location))}`}
        state={{ from: location }}
        replace
      />
    );
  }

  return children;
}
